import { MaterialUpdateFormValues } from './types';

export const defaultValues: MaterialUpdateFormValues = {
  final: false,
  optionsAttributes: [
    {
      id: '',
      name: '',
      unit: '',
      valueType: '',
      doubleEntryRequired: false,
      finalQuantity: '',
      finalQuantityRepeat: '',
      required: false,
    },
  ],
};
